import React, { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { PlanType } from '../../components/enums/plan-type';
import Tiers from '../../components/tiers';
import { getQualifiedDependents, hasQualifiedDependents, isMarried } from '../../components/contact-builder';
import { updateSelection } from '../../redux/actions/enrollments-actions';
import { refreshCompanyPaidPlan } from '../../components/company-paid-plan-modifier';

const CompanyPaid = ({reset, refreshCompanyPaid, setRefreshCompanyPaid}) => {
    const enrollments = useSelector(s => s.enrollments);
    const [hasDependents, setHasDependents] = useState();
    const {setValue} = useFormContext();
    const [disabled,setDisabled] = useState(true);
    const [plan, setPlan] = useState();
    const [planOption, setPlanOption] = useState();
    const dispatch = useDispatch();

    useEffect(() => {
        if(Array.isArray(enrollments))
            return;
        
      const hasQualified = hasQualifiedDependents(enrollments);
      const married = isMarried(enrollments);
      const selectedPlan = enrollments.plans.find((p) => p.planType === PlanType.BasicLife);
      if(!refreshCompanyPaid)
        setRefreshCompanyPaid(true);
      setPlan(selectedPlan);
      setHasDependents(hasQualified);
      setDisabled(hasQualified || married);

      setValue("spousePaid", hasQualified);
    }, [enrollments,reset]);

    useEffect(() => {
      var updatedCompanyPaidPlan = refreshCompanyPaidPlan(enrollments);
      if(updatedCompanyPaidPlan)
        dispatch(updateSelection(updatedCompanyPaidPlan));
    }, [refreshCompanyPaid, reset]);
   
    return ( 
        <>
          <div className='mb-4 mt-2'>
            <div className='text-2xl text-danger'>Company Paid</div>
            <div className='text-gray-400'>This benefit is provided at no cost to you</div>
          </div>
          <div className="pl-4">

            <p className="font-bold mb-2">
              Basic Life insurance (Employee)
            </p>
            {/*}
            <div className="font-bold mb-8 ml-4">
              {enrollments?.insuranceCoverage?.employeeBenefit}
            </div>
            */}
            {hasDependents ?
              <>
                <p className="font-bold mb-2">
                Basic Life insurance (Spouse/Domestic Partner/Child)
                </p>
                <div className="font-bold mb-8 ml-4">
                  Spouse: {enrollments?.insuranceCoverage?.spouseBenefit} <br />
                  Children 6 mo - 26 yrs: {enrollments?.insuranceCoverage?.childBenefit} <br />
                  Children under 6 months: {enrollments?.insuranceCoverage?.infantBenefit} <br />
                </div>
              </>
            :
            <div className='mt-2'>
            In order to take advantage of Company Paid life for dependents, you must add dependents on the dependents step.
            </div>
            }
              <Tiers 
                plan={plan} 
                planOption={planOption}
                setPlanOption={setPlanOption}
                type={PlanType.BasicLife} 
                reset={reset} 
                setDisabled={setDisabled}
                disabled={disabled}
              />

            </div>
            
        </>
    );
}
 
export default CompanyPaid;